let resumeData = {
    "name": "Umesh Dhurvas",
    "role": "Mobile and web developer ... Aspiring Full stack developer",
    "linkedinId":"linkedin.com/in/umesh-dhurvas",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/umesh-dhurvas",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"http://github.com/ubbop42",
          "className":"fa fa-github"
        },
      ],
    "aboutme":"Im a computer engineering new grad from University of Waterloo with a industry Experience in Android and Web development. I have a strong understanding of Object-Oriented programming and moder web frameworks such as React and Angular. Passion for creating complex front end components in web and mobile applications working closely with designers. Work experience with building an GraphQL API using Apollo Server and Node.js. Versatile development mindset with the ability and desire to pick up different languages and technologies. Passion for problem solving, learning and communicating with an entrepreneurial spirit. ",
    "website":"https://rbhatia46.github.io",
    "education":[
      {
        "UniversityName":"University of Waterloo",
        "specialization":"Computer Engineering",
        "MonthOfPassing":"June",
        "YearOfPassing":"2020",
      },
    ],
    "work":[
      {
        "CompanyName":"Flybits",
        "specialization":"Android developer",
        "MonthOfLeaving":"Dec",
        "YearOfLeaving":"2020",
        "Achievements":"Developed new features and pages for two external SDK’s using Kotlin coroutines, Caching and Room Api. Redesigned Push notifications to accommodate different types of push notifications and silent messages and reducing 10K lines of code in an external client SDK. Release manager for multiple android releases using Github and Circleci."
      },
      {
        "CompanyName":"Ecobee",
        "specialization":"GraphQL Web Developer",
        "MonthOfLeaving":"Dec",
        "YearOfLeaving":"2018",
        "Achievements":"Contributed in building an aggregation layer in Node.js that stitches together various Rest APIs using GraphQL and Apollo Server. Implemented GraphQL subscriptions with web sockets and Kafka event streams after conducting a research spike ."
      },
      {
        "CompanyName":"TribalScale",
        "specialization":"Agile Developer",
        "MonthOfLeaving":"Apr",
        "YearOfLeaving":"2018",
        "Achievements":"Developed new features for CBS Radio.com Android application using Kotlin in a pair programming setup.Developed front end and backend features for RBC MyBenefits Web app using React and Redux following TDD.Built POC’s using React. Js and material-ui for two venture studio projects."
      },
      {
        "CompanyName":"Peleton Innovations",
        "specialization":"Junior Mobile and Web Developer",
        "MonthOfLeaving":"Oct",
        "YearOfLeaving":"2017",
        "Achievements":"Developed a realtime Angular(Ionic) web and mobile application using ReactiveX and Redux methodologies.Built an ‘Uber like map’ Angular component/directive using Google maps and roads API.Created server-side Java services for database Management with MongoDB and Apache POI."
      },
      {
        "CompanyName":"Teranet",
        "specialization":"Application Developer",
        "MonthOfLeaving":"Apr",
        "YearOfLeaving":"2016",
        "Achievements":"Developed new features for GeoWarehouse Application Using Javascript and AngularJS. Other contributions are automation test scripts using Protractor, Google Analytics, Ant scripts and Java unit testing. Developed back-end Java Rest API for search services using Apache Lucene."
        
      }
    ],
    "skills":[
      {
        "skillname":"React.js",
        "class" : "reactjs"
      },
      {
        "skillname":"Angular",
        "class" : "angular"
      },
      {
        "skillname":"Javascript",
        "class" : "javascript"
      },
      {
        "skillname":"HTML5",
        "class" : "html5"
      },
      {
        "skillname":"CSS",
        "class" : "css"
      },
      {
        "skillname":"Android",
        "class" : "android"
      },
      {
        "skillname":"Java",
        "class" : "java"
      },
      {
        "skillname":"Kotlin",
        "class" : "kotlin"
      },
      {
        "skillname":"Node JS",
        "class" : "node"
      },
      {
        "skillname":"GraphQL",
        "class" : "graphql"
      },
      {
        "skillname":"Python(Pandas + Keras)",
        "class" : "python"
      },

    ],
    "portfolio":[
      {
        "name":"Stock Market Prediction",
        "description":"Predict stock market trends using neural networks with sentiment analysis with NLTK.Vader on News data with an accuracy of 60%.",
        "imgurl":"https://colab.research.google.com/drive/1jgAdMRftVLfmPHBwP7pZwB9z-L1MT7O1?usp=sharing"
      },
      {
        "name":"MapBot",
        "description":"A remote-controlled robot able to produce a 3D mapping of an environment from an RGB video feed using SLAM and RSTP video stream from android app. Built the android app and node.js server",
        "imgurl":"images/mapbot.png"
      },
      {
        "name":"Thumb Trainer - 389112",
        "description":"An Android app/game where the user has to come with as many combinations of the 3x3 matrix lock pattern",  
        "imgurl":"https://github.com/ubbop42/ece452"
      },
      {
        "name":"RetroActive",
        "description":"Responsive Web Application for Retros using React.js with material-ui.",  
        "imgurl":"https://retroactive-6ba30.firebaseapp.com/"
      },
      {
        "name":"thegrandtourlaptimes.com",
        "description":"An Angular App displaying the leaderboard of all the lap time on The Grand Tour TV Show.",
        "imgurl":"https://thegran-d70f9.web.app"
      },
      {
        "name":"Be Strong",
        "description":"Founder of Be Strong, A small proprieteship that manufactures and sells workout acessories through Amazon and local distributors",
        "imgurl":"https://www.amazon.in/s?me=A2UEZQJ9KIT9T9&marketplaceID=A21TJRUUN4KGV"
      },
      {
        "name":"BW to Color video using Python",
        "description":"Used Python and OpenCV to colorize and upscale an old video I found of my hometown.",
        "imgurl":"https://www.youtube.com/watch?v=zAJvzCVd2U0&t=233s"
      }
    ],
    "hobbies":[
      {
        "name":" Aspiring Armwrestler",
        "imgurl":"images/armwrestling.jpg",
        "url":"https://www.youtube.com/watch?v=cHS1eHuAHwE"
      },
      {
        "name":"Motorcycles",
        "imgurl":"images/bike.jpg",
        "url":"https://www.instagram.com/umesh_dhurvas/"
      },
      {
        "name":"Photography", 
        "imgurl":"images/header-background.jpg",
        "url":"https://500px.com/p/umeshfan?view=photos"
      },
      {
        "name":"Film Making",
        "imgurl":"images/video.png",
        "url":"https://www.youtube.com/channel/UC9VY9K7H-bkFzRqw-lIXFNw"
      }
    ]
  }
  
  export default resumeData